var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import CreateOrEditProjectCategoryDialog from '@/views/Projects/CreateOrEditProjectCategoryDialog/CreateOrEditProjectCategoryDialog.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { ProjectCategory } from '@/models/ProjectCategory';
let ProjectCategories = class ProjectCategories extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'ProjectCategories';
        // #region @VModel
        // #endregion
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isCreatingOrEditingCategory = false;
        this.selectedCategory = null;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    onClickCreate() {
        this.isCreatingOrEditingCategory = true;
    }
    onCloseCreateOrEditDialog() {
        this.isCreatingOrEditingCategory = false;
        this.selectedCategory = null;
    }
    // #endregion
    // #region Class methods
    refreshDataTable() {
        this.isCreatingOrEditingCategory = false;
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    // #endregion
    // #region Async methods (api calls only)
    async refreshFilterStore() {
        await new ProjectCategory()
            .all()
            .then((projectCategories) => {
            const mutatedProjectCategories = [];
            const payload = {};
            projectCategories.forEach((projectCategory) => {
                mutatedProjectCategories.push({
                    value: projectCategory.id,
                    text: projectCategory.getFilterLabel(),
                });
            });
            payload.ProjectCategory = mutatedProjectCategories;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    // #endregion
    // #region Getters & Setters
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('Goal set category', 1),
                plural: this.$tc('Goal set categories', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    editable: false,
                    changed: false,
                    action: '/project-categories/{id}',
                },
                {
                    text: this.$t('Amount of goal sets'),
                    value: 'project_count',
                    editable: false,
                    changed: false,
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    visible: (vm, projectCategory) => {
                        return true;
                    },
                    action: (vm, projectCategory) => {
                        if (!projectCategory || !projectCategory.id) {
                            return;
                        }
                        this.$router.push({ name: 'project-category.index', params: { id: projectCategory.id } });
                    },
                },
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    visible: (vm, projectCategory) => {
                        return projectCategory && projectCategory.name !== 'Algemeen';
                    },
                    action: (vm, projectCategory) => {
                        if (!projectCategory || !projectCategory.id) {
                            return;
                        }
                        this.selectedCategory = projectCategory;
                        this.isCreatingOrEditingCategory = true;
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    visible: (vm, projectCategory) => {
                        return projectCategory && projectCategory.name !== 'Algemeen';
                    },
                    action: (vm, projectCategory) => {
                        this.selectedCategory = projectCategory;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: this.isMyProjectCategories ? new ProjectCategory().filter({ created_by: this.user.id }) : new ProjectCategory(),
        };
    }
    get dialogOptions() {
        const category = this.selectedCategory;
        return {
            title: this.$tc('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: category.name }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!category) {
                            return;
                        }
                        category
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedCategory = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedCategory = null;
                    },
                },
            },
        };
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isMyProjectCategories() {
        const route = this.$route;
        const meta = route.meta;
        return meta && meta.myProjectCategories ? true : false;
    }
    get title() {
        return this.isMyProjectCategories ? this.$tc('My goal set categories') : this.$tc('All goal set categories');
    }
};
ProjectCategories = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CreateOrEditProjectCategoryDialog,
        },
    })
], ProjectCategories);
export default ProjectCategories;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
